import React, { useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { useOrderSaleOrderSaleReceiptTypeInputQuery } from '../../../../../../../../services';
import { RhCheckbox } from '../../../../../../../dum';
import {
    AUTOMATIC_TAX_CALCULATION,
    IOrderSale,
    REQUIRE_TAX,
    TAX,
} from '../../order-sale-form';
import { useSetOrderSaleTaxRequirement } from '../../use-set-order-sale-tax-requirement';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function OrderSaleRequireTaxInput() {
    const { setOrderSaleTaxRequirement } = useSetOrderSaleTaxRequirement();
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IOrderSale['receipt_type_id'];
    const tax = useWatch({ name: TAX }) as IOrderSale['tax'] | string;
    const automaticTaxCalculation = useWatch({
        name: AUTOMATIC_TAX_CALCULATION,
    }) as IOrderSale['automatic_tax_calculation'];
    const previousTaxRef = useRef<IOrderSale['tax']>(Number(tax) || 0);
    const previousAutomaticTaxCalculationRef = useRef(
        automaticTaxCalculation,
    );
    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );

    return (
        <RhCheckbox
            name={REQUIRE_TAX}
            label={shortLabel(FIELD_LABELS.require_tax)}
            disabled={!!receiptType && !receiptType.applies_tax}
            onChange={(required) => {
                if (required) {
                    setOrderSaleTaxRequirement(true, {
                        automaticTaxCalculation:
                            previousAutomaticTaxCalculationRef.current ?? true,
                        taxToRestore: previousTaxRef.current,
                    });
                } else {
                    const numericTax = Number(tax);
                    if (tax !== '' && Number.isFinite(numericTax)) {
                        previousTaxRef.current = numericTax;
                    }
                    previousAutomaticTaxCalculationRef.current =
                        automaticTaxCalculation;
                    setOrderSaleTaxRequirement(false);
                }
            }}
        />
    );
}
